"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M8 2.667A5.344 5.344 0 003.117 5.86a5.335 5.335 0 00.956 5.754 5.345 5.345 0 007.854 0 5.335 5.335 0 00.956-5.754A5.344 5.344 0 008 2.667zm0 9.61a4.277 4.277 0 01-2.966-1.202 3.206 3.206 0 015.932 0A4.277 4.277 0 018 12.277zm-1.069-5.34a1.068 1.068 0 112.137.002 1.068 1.068 0 01-2.137-.001zm4.761 3.204a4.274 4.274 0 00-2.089-1.804 2.134 2.134 0 00-.124-2.954 2.139 2.139 0 00-2.958 0 2.134 2.134 0 00-.124 2.954 4.274 4.274 0 00-2.09 1.804 4.226 4.226 0 01-.582-2.135A4.273 4.273 0 018 3.734a4.273 4.273 0 014.275 4.272 4.22 4.22 0 01-.583 2.135z",
        id: "prefix__a"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "prefix__b",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#prefix__a"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fill: "currentColor",
        fillRule: "nonzero",
        xlinkHref: "#prefix__a"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "currentColor",
        mask: "url(#prefix__b)",
        d: "M0 0h16v16H0z"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=UserCircle.js.map